<template>
  <el-dialog
    title="选择商家优惠券"
    :visible.sync="dialogVisible"
    width="70%"
    top="5vh"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-input
          v-model="searchText"
          placeholder="输入商家优惠券池名称"
          style="width:300px;margin-bottom:20px"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleSearch"
          />
        </el-input>
        
        <el-table
          :data="couponList"
          border
          style="width:100%"
        >
          <el-table-column
            prop="poolId"
            label="优惠券编码"
            align="center"
          />
          <el-table-column
            prop="couponName"
            label="优惠券名称"
            align="center"
          />
          <el-table-column
            prop="actualPrice"
            label="面值"
            align="center"
          />
          <el-table-column
            prop="stock"
            label="库存"
            align="center"
          />
          <el-table-column
            prop="validityDay"
            label="有效期"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="handleSelect(scope.row)"
              >选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="handlePageChange"
          style="margin-top:20px"
        />
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listCouponShopPool } from '@/api/goods/buyGoldSendApi.js'

export default {
  name: 'ChooseCouponShopPool',
  data() {
    return {
      dialogVisible: false,
      searchText: '',
      couponList: [],
      page: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getCouponList()
    },
    async getCouponList() {
      try {
        const res = await listCouponShopPool({
          page: this.page,
          row: this.pageSize,
          couponName: this.searchText
        })
        this.couponList = res.data
        this.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch() {
      this.page = 1
      this.getCouponList()
    },
    handlePageChange(val) {
      this.page = val
      this.getCouponList()
    },
    handleSelect(row) {
      this.$emit('selected', row)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.el-dialog__body {
  padding: 20px;
}
</style>